import { FormWithUnsavedChangesPrompt } from '@components/generic-modals';
import { Sidebar } from '@components/sidebar';

import { useEmailAddressOptions } from 'api/company/hooks';
import { useJourneyAction, useUpdateJourneyAction } from 'api/journey-actions/hooks';
import { ACTION_TYPES } from 'ui/actions/action-config';
import { TimeSavedContainer } from 'ui/helpers';
import {
  ActionFooter,
  ActionHeader,
  ActionSidebarLoading,
  createActionForm,
  SidebarProps,
  useCreateActionFormStore,
} from 'ui/journey-builder/node-types/common';

import { ActionType, CalendarEventData, CalendarEventFormFields, formatFormData } from './common';

const ACTION_TYPE = ACTION_TYPES.calendar_event;
const Form = createActionForm<CalendarEventData>();

export const SidebarContent = (props: SidebarProps) => {
  const { journeyActionId } = props;
  const formStore = useCreateActionFormStore();
  const isDirty = formStore.useIsDirty();
  const emailAddressOptions = useEmailAddressOptions();

  const { data, isLoading } = useJourneyAction<ActionType>(journeyActionId);

  const editMutation = useUpdateJourneyAction(journeyActionId);
  const handleSave = (data: CalendarEventData) => {
    return editMutation.mutateAsync(formatFormData(data));
  };

  if (isLoading || !data || emailAddressOptions.isLoading) {
    return <ActionSidebarLoading actionType={ACTION_TYPE} {...props} />;
  }
  return (
    <Sidebar>
      <ActionHeader actionType={ACTION_TYPE} {...props} />
      <Sidebar.Content>
        <FormWithUnsavedChangesPrompt store={formStore} onSubmit={handleSave}>
          <CalendarEventFormFields
            Form={Form}
            emailAddressOptions={emailAddressOptions}
            data={data}
          />
          <Sidebar.Separator />
          <TimeSavedContainer {...data.timeSaved} />
          <ActionFooter action={data} isDisabled={!isDirty || editMutation.isLoading} form={Form} />
        </FormWithUnsavedChangesPrompt>
      </Sidebar.Content>
    </Sidebar>
  );
};
